import React from 'react';
import Modal from 'react-modal';
import _ from 'lodash';
import '../css/SystemIntegratorAdd.css';
import ErrorText from '../ErrorText';
import Loader from './Loader';
import SnackBar from './SnackBar';
import { MenuItem, TextField } from '@mui/material';
import DynamicAccordion from './user-management/permissionAccordian';
import { modulesDataSI } from './constant/permisions';


// Distributor page to add new Distributor page

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        backgroundColor: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


const customStylesSuccess = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


export default class RoleAddNew extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
            noOfParams: [],
            SiUsername: '',
            SiCompany: '',
            name: '',
            SiEmail: '',
            SiMobile: '',
            SiArea: '',
            DistributorCountry: '',
            SiAddress: '',
            errorMessage: [],
            modalIsOpenSuccess: false,
            showErrorMessage: false,
            usernameAvailable: true,
            siData: [],
            indianCityWithState: [],
            loader: false,
            SiGST: '',
            snackbarActive: false,
            snackbarMessage: '',
            selectedPermissions: {},
            initial_permissions: {},
            permissions: [],
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSuccess = this.closeModalSuccess.bind(this);

    }


    getPermissions() {
        // console.log(modulesData)
        return modulesDataSI;
    }

    // getPermissions() {
    //     const userType = localStorage.getItem('user_type');
    //     let modulesData = [];

    //     if (userType === '1') {
    //         modulesData = modulesDataSI;
    //     } else if (userType === '2') {
    //         const { permissions } = this.state;

    //         if (
    //             Array.isArray(permissions) &&
    //             permissions.length > 0 &&
    //             typeof permissions[0] === 'object' &&
    //             permissions[0] !== null
    //         ) {
    //             modulesData = Object.entries(permissions[0]).map(([module, actions]) => ({
    //                 module,
    //                 actions
    //             }));
    //         }
    //     }

    //     return modulesData;
    // }


    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModalSuccess() {
        this.setState({
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp',
            modalIsOpen: false
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpenSuccess: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }

    afterOpenModal() {

    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp',

        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }


    componentDidMount() {
        this.fecthAllDistributor();
    }

    fecthAllDistributor = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/distributors/', { // Change to Distributor
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({forceRefresh: true})
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    siData: data.data
                })
                // console.log(data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }


    AddingRoles(type) {
        const { name, selectedPermissions } = this.state;

        // ✅ Check for empty name
        if (!name.trim()) {
            alert("Please enter a role name.");
            return;
        }

        // ✅ Check for empty permissions
        if (!selectedPermissions || Object.keys(selectedPermissions).length === 0) {
            alert("Please select at least one permission.");
            return;
        }

        const jsonData = {
            name,
            permissions: selectedPermissions,
        };

        fetch(this.state.role_id ? `/cloud/addRoles_detail/${this.state.role_id}` : "/cloud/addRoles/", {
            method: this.state.role_id ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": localStorage.getItem("csrftoken"),
            },
            body: JSON.stringify(jsonData),
        })
            .then(response => {
                if (response.status === 403) {
                    window.location = "/login/session-timeout";
                }
                return response.json();
            })
            .then((data) => {
                if (type === "add") {
                    this.setState({
                        name: "",
                        selectedPermissions: {},
                        successmsgmodaldata: 'dataadded'
                    });
                    alert("Role added successfully!")
                    this.closeModal();
                }
            })
            .catch((error) => {
                console.error("❌ Error adding role:", error);
            });
    }


    AddRoles = () => {
        const { name, selectedPermissions } = this.state;

        // Set error message visibility
        this.setState({ showErrorMessage: true });

        // Simple validation
        if (!name.trim()) {
            alert("Please enter a role name.");
            return;
        }

        if (!selectedPermissions || Object.keys(selectedPermissions).length === 0) {
            alert("Please select at least one permission.");
            return;
        }

        // Show loader and proceed with role addition
        this.setState({ loader: true }, () => {
            this.AddingRoles("add"); // Pass "add" if needed
        });
    }


    render() {
        return (
            <React.Fragment>
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas fa-timess fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Add New User Role</h3>
                    <div className="row">
                        {this.state.addAnotherSuccess ? <div class="col-12 my-2 alert alert-success fade show" role="alert">
                            Successfully registered the Role.
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            </button>
                        </div> : null}
                    </div>
                    <div className="row">

                        <div className="modal-body modfields">
                            <TextField
                                label="Group Name"
                                type="text"
                                name="name"
                                id="name"
                                fullWidth
                                variant="standard"
                                required
                                value={this.state.name}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    const filtered = input.replace(/[^a-zA-Z ]/g, '').slice(0, 25); // Only letters and spaces, max 25 characters
                                    this.setState({ name: filtered, addresserror: false });
                                }}
                                onPaste={(e) => {
                                    const pastedData = e.clipboardData.getData('text');
                                    if (!/^[a-zA-Z ]+$/.test(pastedData)) {
                                        e.preventDefault(); // Prevent pasting invalid content
                                    }
                                }}
                                error={Boolean(this.state.addresserror)}
                                helperText={
                                    this.state.addresserror ? "Only letters and spaces are allowed (max 25 characters)" : ""
                                }
                                inputProps={{
                                    maxLength: 25,
                                }}
                                style={{ marginBottom: "10px" }}
                            />

                            <DynamicAccordion initial_permissions={this.state.selectedPermissions} modulesData={this.getPermissions()} onChange={(selectedPermissions) => { this.setState({ selectedPermissions }) }} />

                            <span className="fieldmend"></span>
                        </div>


                    </div>
                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey" style={{ marginRight: '15px' }} onClick={this.closeModal}>Cancel</div>

                        <i className="fa fa-star-christmas fa-spin"></i>
                        <div className="btn btn-new-green " onClick={this.AddingRoles.bind(this, 'add')}>Add</div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpenSuccess}
                    style={customStylesSuccess}
                    className={this.state.modalStateAftereOpenSuccess}
                    contentLabel="Example Modal">
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                            <i className="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">User Added Successfully</h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={this.closeModalSuccess}>
                            Close
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
